// Dashboard related store state and actions.

import _ from 'lodash'
import moment from 'moment-timezone'
import * as Sentry from '@sentry/vue'
import { getSavedState, saveState } from '../helpers'
import axiosApiClient from '@/api/axiosApiClient'

const POLLING_INTERVAL = 5 * 60 * 1000

const initialFilter = {
	date: new Date().toISOString().slice(0, 10),
	clientId: ''
}

// State
export const state = {
	statusCount: {},
	lastUpdateTime: '',
	filter: initialFilter,
	showDashboard: Boolean(getSavedState('dashboard.show')),
	polling: null,
	isFetching: false,
	errorMsg: ''
}

// Mutations
export const mutations = {
	SET_FILTER(state, filter) {
		state.filter = { ...state.filter, ...filter }
	},
	SET_OVERVIEW(state, { statusCount, lastUpdatedTime }) {
		state.statusCount = statusCount
		state.lastUpdateTime = moment
			.utc(lastUpdatedTime)
			.local()
			.format('YYYY-MM-DD HH:mm:ss')
	},
	TOGGLE_DASHBOARD(state) {
		const currentState = state.showDashboard
		state.showDashboard = !currentState
		saveState('dashboard.show', !currentState)
	},
	RESET_TOGGLE(state) {
		state.showDashboard = false
		saveState('dashboard.show', false)
	},
	SET_POLLING(state, { commit }) {
		state.polling = setInterval(() => {
			actions.fetchOverview({ commit })
		}, POLLING_INTERVAL)
	},
	CLEAR_POLLING(state) {
		clearInterval(state.polling)
		state.polling = null
	},
	SET_IS_FETCHING(state, isFetching) {
		state.isFetching = isFetching
	},
	SET_ERROR(state, errorMsg) {
		state.errorMsg = errorMsg
	}
}

// Getters
export const getters = {}

// Actions
export const actions = {
	async fetchOverview({ commit }) {
		commit('SET_IS_FETCHING', true)
		try {
			const response = await axiosApiClient.get(
				'/portal/v1/delivery-overview',
				{ params: state.filter }
			)
			commit('SET_OVERVIEW', response.data)
		} catch (err) {
			const errorStatus = _.get(err, 'response.status')
			let errorMsg = ''

			if (
				errorStatus === 429 &&
				_.get(err, 'response.data.code') === 'ATTEMPTS_EXCEEDED_LIMIT'
			) {
				errorMsg = err.response.data.message
			} else if (
				errorStatus === 422 &&
				_.get(err, 'response.data.errors.0.code') === 'UNPROCESSABLE'
			) {
				errorMsg = err.response.data.errors[0].detail
			} else {
				errorMsg =
					'Unable to retrieve the information. Please try again.'
				Sentry.captureException('dashboard:fetchOverview', {
					level: 'error',
					extra: {
						error: err
					}
				})
			}

			commit('SET_ERROR', errorMsg)
		}
		commit('SET_IS_FETCHING', false)
	},
	initClientFilter({ commit, rootState }) {
		// initialize client filter if not defined
		if (!state.filter.clientId) {
			const { clients } = rootState.config
			commit('SET_FILTER', {
				clientId: clients[0]?.id || ''
			})
		}
	},
	toggleDashboard({ commit }) {
		commit('TOGGLE_DASHBOARD')
	},
	resetDashboard({ commit }) {
		commit('RESET_TOGGLE')
		commit('CLEAR_POLLING')
		commit('SET_OVERVIEW', initialFilter)
	},
	setPolling({ commit }) {
		commit('SET_POLLING', { commit })
	},
	clearPolling({ commit }) {
		commit('CLEAR_POLLING')
	},
	dismissError({ commit }) {
		commit('SET_ERROR', '')
	}
}
